type ClassValue = string | number | boolean | null | undefined | ClassValue[];

/**
 * Lightweight className joiner — joins truthy values with spaces and
 * flattens nested arrays. Compatible with the `cn` helper found in shadcn
 * projects (no dedupe of Tailwind classes; we do not bring clsx + twMerge
 * for a single utility).
 */
export function cn(...values: ClassValue[]): string {
  const out: string[] = [];
  const walk = (v: ClassValue) => {
    // Mirror clsx semantics: skip null, undefined, and booleans — but NOT
    // numbers (including 0), and NOT empty strings (kept as [] no-op below).
    if (v === null || v === undefined || typeof v === 'boolean') return;
    if (Array.isArray(v)) {
      v.forEach(walk);
      return;
    }
    if (v === '') return;
    out.push(String(v));
  };
  values.forEach(walk);
  return out.join(' ');
}
